import {ModuleWithProviders, NgModule, OnInit} from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {NmdpWidget, NmdpWidgetModule} from '@nmdp/nmdp-login';
import { HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatListModule} from '@angular/material/list';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule, MatOptionModule} from '@angular/material/core';
import {MatRadioModule} from '@angular/material/radio';
import {MatInputModule} from '@angular/material/input';
import {MatCardModule } from '@angular/material/card';
import { NgSelectModule } from '@ng-select/ng-select';
// General Modules
import { CoreModule } from './core/core.module';
// Pages (StateFul Components)
import { AppComponent } from './app.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ModalComponent } from './modal/modal.component';
import { ModalEditComponent } from './modal/modal.edit.component';
import { NotesComponent } from './components/dashboard/notes/notes.component';
import { SubmissionHistoryTableComponent } from './components/dashboard/submission-history/submission-history-table.component';
import { SubmissionSearchComponent } from './components/dashboard/submission-history/submission-search.component';
import { SubmissionHistoryComponent } from './components/dashboard/submission-history/submission-history.component';
import { SubmissionDetailsComponent } from './components/dashboard/submission-details/submission-details.component';
import { SampleSearchComponent } from './components/dashboard/sample-search/sample-search.component';
import { SampleSearchTableComponent } from './components/dashboard/sample-search/sample-search-table.component';
import { SampleSearchSidebarComponent } from './components/dashboard/sample-search/sample-search-sidebar.component';
import { SampleDetailsComponent } from './components/dashboard/sample-details/sample-details.component';
import { SampleDetailsTableComponent } from './components/dashboard/sample-details/sample-details-table.component';
import { SampleDetailsSidebarComponent } from './components/dashboard/sample-details/sample-details-sidebar.component';
import { SubmissionDetailsTableComponent } from './components/dashboard/submission-details/submission-details-table.component';
import { SubmInfoSidebarComponent } from './components/dashboard/submission-details/submInfo-Sidebar.component';

import { NotesService } from './shared/services/notes.service';
import { ModalService } from './shared/services/modal.service';
import { SubmissionHistoryService } from './shared/services/submission-history.service';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { SamplePaginationComponent } from './components/dashboard/sample-search/pagination.component';
import { PaginationComponent } from './components/dashboard/submission-history/pagination.component';
import { MatPaginatorModule } from '@angular/material/paginator';

import { ConfigService } from './config/config.service';
import { NgxNewstickerAlbeModule } from 'ngx-newsticker-albe';
import { AdminRootComponent } from './components/dashboard/admin-root.component';
import { AnnouncementForm } from './components/dashboard/admin/announcement/announcement-form/announcement.component';
import { AnnouncementPage } from './components/dashboard/admin/announcement/announcement-page/announcement-page.component';
import { ViewAnnouncements } from './components/dashboard/admin/announcement/view_announcements/view_announcements.component';
import { AnnouncementService } from './shared/services/announcement.service';
import { CreateAnnouncement } from './components/dashboard/admin/announcement/create_announcement/create_announcement.component';
import { BaseComp } from './components/dashboard/admin/announcement/announcement-form/base/base.component';
import { AnnouncementPaginationComponent } from './components/dashboard/admin/announcement/view_announcements/pagination.component';
import { MatSelectModule } from '@angular/material/select';
import { KpiRootComponent } from './components/dashboard/kpi-root.component';
import { KpiComponent } from './components/dashboard/kpi/kpi.component';
import { KpiSearchComponent } from './components/dashboard/kpi/kpi-search.component';
import {ChartCommonModule, NgxChartsModule} from '@swimlane/ngx-charts';
import {KpiLineChartComponent} from './components/dashboard/kpi/kpi-widget-components/kpi-line-chart.component';
import {KpiBarChartComponent} from './components/dashboard/kpi/kpi-widget-components/kpi-bar-chart.component';
import {KpiPieChartComponent} from './components/dashboard/kpi/kpi-widget-components/kpi-pie-chart.component';
import {KpiService} from './shared/services/kpi.service';
import {NavbarComponent} from "./components/dashboard/navbar/navbar.component";
import {FooterComponent} from "./components/dashboard/footer/footer.component";
import {PandoraAsideComponent} from "./components/dashboard/pandora-aside/pandora-aside.component";

@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent,
        ModalComponent,
        NotesComponent,
        SubmissionDetailsComponent,
        SubmissionHistoryTableComponent,
        BreadcrumbComponent,
        SubmissionSearchComponent,
        SubmissionHistoryComponent,
        SubmissionDetailsTableComponent,
        SampleSearchComponent,
        SampleSearchTableComponent,
        SampleSearchSidebarComponent,
        SampleDetailsComponent,
        SampleDetailsTableComponent,
        SampleDetailsSidebarComponent,
        SubmInfoSidebarComponent,
        PaginationComponent,
        SamplePaginationComponent,
        AnnouncementPaginationComponent,
        ModalEditComponent,
        AnnouncementForm,
        AnnouncementPage,
        ViewAnnouncements,
        CreateAnnouncement,
        AdminRootComponent,
        BaseComp,
        KpiRootComponent,
        KpiComponent,
        KpiSearchComponent,
        KpiLineChartComponent,
        KpiBarChartComponent,
        KpiPieChartComponent,
        FooterComponent,
        NavbarComponent,
        PandoraAsideComponent,
        NotesComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        HttpClientJsonpModule,
        FormsModule,
        NmdpWidgetModule.forRoot((window.location.hostname === 'localhost' ? window.location.origin + '/assets/HMLDashboard-login.json' : window.location.origin + '/dashboardui/assets/HMLDashboard-login.json')),
        ModalModule.forRoot(),
        NgbModule,
        CoreModule.forRoot(),
        BrowserAnimationsModule,
        MatDatepickerModule,
        MatToolbarModule,
        MatTooltipModule,
        MatButtonModule,
        MatRadioModule,
        MatListModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        MatCardModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatOptionModule,
        NgSelectModule,
        ReactiveFormsModule,
        AppRoutingModule,
        NgxNewstickerAlbeModule,
        ChartCommonModule,
        NgxChartsModule
    ],
    providers: [
        ModalService,
        NotesService,
        SubmissionHistoryService,
        KpiService,
        NmdpWidget,
        ConfigService,
        AnnouncementService,
        {
        provide: APP_BASE_HREF, useValue: '/dashboardui'
        }
    ],
    bootstrap: [ AppComponent ]
})
export default class AppModule {
}
